import React from "react";
import { IScene } from "./types";
import { SceneListClickItem, SceneListToggleItem } from "./SceneListItem";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../contexts/UserProvider";
import FloatingActionButton from "../../Components/FloatingActionButton";
import { Grid } from "@mui/material";

type TScenesPanelProps = {
  scenes: IScene[];
};

const SceneList = (props: TScenesPanelProps) => {
  const { scenes } = props;
  const navigate = useNavigate();
  const { user } = useUser();
  const handleAddUser = () => navigate("/scenes/-1");
  return (
    <>
      <Grid
        container
        padding={{ xs: 1, sm: 1 }}
        spacing={{ xs: 1, sm: 1 }}
        data-cy="scenes"
      >
        {scenes.map((scene, index) => {
          return scene.scene_type === "enable_automations" ? (
            <SceneListToggleItem key={index} scene={scene} />
          ) : (
            <SceneListClickItem key={index} scene={scene} />
          );
        })}
      </Grid>
      {user?.is_operator && (
        <FloatingActionButton
          iconName="plus"
          onClick={handleAddUser}
          data-cy="scene-add"
        />
      )}
    </>
  );
};

export default SceneList;
